const staticRouter = [
  {
    path: "",
    name: "Index",
    component: () => import("./index/index.vue")
  },
  {
    path: "signin",
    name: "SignIn",
    component: () => import("./signin/signin.vue"),
    meta: { HOME_LOGIN: true }
  },
  {
    path: "repayment-detail",
    name: "RepaymentDetail",
    component: () => import("./repaymentDetail/repaymentDetail.vue"),
    meta: { HOME_LOGIN: true }
  },
  {
    path: "repayment-code",
    name: "RepaymentCode",
    component: () => import("./repaymentCode/repaymentCode.vue"),
    meta: { HOME_LOGIN: true }
  },
  {
    path: "elec-sign",
    name: "ElecSign",
    component: () => import("./elecSign/elecSign.vue"),
    meta: { onlyApp: false, title: "Perjanjian Pinjaman" }
  },
  {
    path: "repayment-payoff",
    name: "RepaymentPayoff",
    component: () => import("./repaymentPayoff/repaymentPayoff.vue"),
    meta: { HOME_LOGIN: true }
  },
  {
    path: "chritma",
    name: "chritmaPrize",
    component: () => import("./chritma/index.vue"),
    meta: { onlyApp: true }
  },
  {
    path: "moon",
    name: "moon",
    component: () => import("./moonActivity/index.vue"),
    meta: { onlyApp: true }
  },
  {
    path: "backSchool",
    name: "backSchool",
    component: () => import("./school/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "indenpendenDay",
    name: "indenpendenDay",
    component: () => import("./indenpendenDay/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "vipPop",
    name: "vipPop",
    component: () => import("./vip/pop.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "vipInfo",
    name: "vipInfo",
    component: () => import("./vip/person.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "vipPopV2",
    name: "vipPopV2",
    component: () => import("./vip/popNew.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "vipInfoV2",
    name: "vipInfoV2",
    component: () => import("./vip/personNew.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "aggreMent",
    name: "aggreMent",
    component: () => import("./vip/aggreMent.vue"),
    meta: { onlyApp: true }
  },
  {
    path: "download",
    name: "download",
    component: () => import("./downLoadLink/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "deeplink",
    name: "deeplink",
    component: () => import("./deepLink/index.vue")
  },
  {
    path: "register",
    name: "register",
    component: () => import("./register/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "personInfo",
    name: "personInfo",
    component: () => import("./personInfo/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "personDetail",
    name: "personDetail",
    component: () => import("./personInfo/detailInfo.vue"),
    meta: { onlyApp: false, title: "Tambah limit" }
  },
  {
    path: "registerV2",
    name: "registerV2",
    component: () => import("./registerV2/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "registerfb",
    name: "registerfb",
    component: () => import("./registerfb/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "registertt",
    name: "registertt",
    component: () => import("./registertt/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "cash",
    name: "cash",
    component: () => import("./cash/index.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "appGuideDownload",
    name: "appGuideDownload",
    component: () => import("./appGuide/index.vue"),
    meta: { onlyApp: false }
  }
];
export default staticRouter;
